export default `# Session Dashboard

The dashboard is your command centre during a live session. It gives you an at-a-glance view of everything happening and quick access to the most common actions.

---

## Layout

### Session Status (top-left)

- **Current phase** name displayed prominently
- **Response Mode** dropdown — controls how avatars respond:

| Mode | Description |
|------|-------------|
| Open Brainstorming | Avatars freely generate creative ideas |
| Structured | Avatars follow a more formal discussion format |
| Solution Focused | Avatars focus on actionable solutions |
| Critique | Avatars challenge and stress-test ideas |
| Silent | Avatars listen but don't contribute automatically |

- **Auto-respond toggle** — When on, avatars contribute automatically. When off, you manually request responses.

### Avatar Activity (top-middle)

Shows up to 4 avatars with their current status:
- **Speaking** (green pulse) — Currently generating or delivering a response
- **Thinking** (amber) — Processing a contribution
- **Idle** (gray) — Listening, waiting for input

### Engagement Metrics (top-right)

- **Engagement score** (0–100%) — Overall conversation health
- **Total contributions** — How many ideas avatars have submitted
- **Acceptance rate** — Percentage of contributions you've accepted

---

## Facilitator Input

The main input area for communicating with avatars:

- Type your message or use the **microphone button** for speech-to-text
- Press **Enter** or click **Send to Avatars** to submit
- Toggle **Auto-respond** to control whether avatars reply automatically

---

## AI Guidance Summary

A compact view of the [Facilitator Guidance](help:session-guidance) panel showing:
- Session progress summary
- Up to 2 suggested prompts (click **Copy** to use them)
- Missing perspectives alert
- Click **Generate** or **Refresh** to update the analysis

---

## Pending Contributions

Shows the 3 most recent avatar suggestions awaiting your review:
- **Accept** (checkmark) — Add to the session
- **Ignore** (X) — Dismiss the suggestion
- Click **View All** to open the full [Contributions](help:session-contributions) panel

---

## Tips

- **Start with Open Brainstorming** then switch to Critique mode once you have enough ideas
- **Watch the engagement score** — If it drops, check which avatars aren't contributing and prompt them directly
- **Use suggested prompts** — The AI guidance often identifies productive next questions`;
